import styled from 'styled-components';

export const TherapyCompanionDashboardContainer = styled.main`
  min-height: 100vh;
  margin: ${({ theme }) => theme.yoga.spacing.zero} auto;
  background-color: ${({ theme }) => theme.yoga.colors.backgroundLight};
`;

export const FirstSection = styled.section`
  padding: ${({ theme }) => theme.yoga.spacing.xlarge}px
    ${({ theme }) => theme.yoga.spacing.xxlarge}px;
`;

export const SecondSection = styled.section`
  height: calc(100vh - 208px);
`;
